import { Attributes, DateUtils, Misc, Model, Rules, Validation } from "@singularsystems/neo-core";
import { InvestmentType } from "../Unauthorised/Investment.enum";

export default class AuditTrailInvestmentCriteria extends Model.CriteriaBase {
    static typeName = "AuditTrailinvestmentCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    public investmentType: InvestmentType = InvestmentType.InvestorInvestment;

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    @Attributes.NoTracking()
    public issuerInvestmentName: string = "";

    @Attributes.Nullable()
    public investorInvestmentId: number | null = null;

    @Attributes.NoTracking()
    public investorInvestmentName: string = "";

    @Rules.Required()   
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AuditTrailInvestmentCriteria>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => !c.investorInvestmentId && c.investmentType === InvestmentType.InvestorInvestment, "Investor Investment is required");
        rules.failWhen(c => !c.issuerInvestmentId && c.investmentType === InvestmentType.IssuerInvestment, "Issuer Investment is required");
    }

    public toString(): string {
        return "Audit Trail Investment Criteria";
    }
}